import { RobotMessage as RobotMessageResponse } from "../../api/HomePageResponseTypes";
import { Classifier } from "../../util/classifierManager";
import { DateString } from "../../util/conversionUtils";

export interface RobotMessage extends Omit<RobotMessageResponse, "tyyp" | "seoseTyyp" | "lisatud"> {
  tyyp: Classifier;
  seoseTyyp?: RelationType;
  lisatud: DateString;
}

export enum RelationType {
  ORGANISATION = "ORGANISATION",
  VARAOBJECT = "VARAOBJECT",
  MENETLUS = "MENETLUS",
  KASUTUSLEPING = "KASUTUSLEPING",
}

export enum ColumnHeader {
  type = "type",
  message = "message",
  link = "link",
  source = "source",
  added = "added",
}
